
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Fast alle Lebewesen haben sich auf den Tag-Nacht-Rhythmus eingestellt. Blüten öffnen und schliessen sich nach der Tageszeit, vermutlich schon die ersten Einzeller reagierten auf den Sonnenstand. `}<M mdxType="M">{`Heute glauben Biologen, dass zumindest alle Säugetiere, wahrscheinlich sogar alle Wirbeltiere schlafen`}</M>{` – und das auf unterschiedlichste Weisen. Um die 20 Stunden am Tag schlafen Fledermäuse, nur ein bis zwei Stunden hingegen die Pottwale, und scheinen so die Hypothese zu bestätigen, dass grosse Tiere weniger Schlaf brauchen. Tiere schlafen zum Teil extrem lang:`}</p>
    <table>
  <tbody>
    <tr>
      <td>Koala</td>
      <td> 15 bis 22 Stunden</td>
    </tr>
    <tr>
      <td>Braune Fledermaus</td>
      <td>20 Stunden</td>
    </tr>
    <tr>
      <td>Igel</td>
      <td>20 Stunden</td>
    </tr>
    <tr>
      <td>Faultier</td>
      <td>17 bis 20 Stunden</td>
    </tr>
    <tr>
      <td>Opossum</td>
      <td>19 Stunden</td>
    </tr>
    <tr>
      <td>Löwe</td>
      <td>19 Stunden</td>
    </tr>
    <tr>
      <td>Gürteltier</td>
      <td>19 Stunden</td>
    </tr>
    <tr>
      <td>Katze</td>
      <td> 16 Stunden</td>
    </tr>
    <tr>
      <td>Lemur</td>
      <td> 16 Stunden</td>
    </tr>
  </tbody>
    </table><br />
    <p>{`Wie Tiere schlafen, hängt von ihrer Grösse, Ernährung und der Gefahrenlage ab, wie Forscher der Universität Zürich in einer gross angelegten Analyse feststellten. `}<M mdxType="M">{`Löwen haben kaum natürliche Feinde und können daher beruhigt den Grossteil des Tages verschlafen.`}</M>{` Faultiere schlafen in Gefangenschaft bis zu 6,5 Stunden mehr als in der freien Natur, wo mehr Feinde lauern und die Nahrungsbeschaffung schwieriger ist. Koalas sind nachtaktiv und schlafen täglich 20 Stunden und mehr. Daneben bleiben rund 4 Stunden für Futtersuche. Auch Igel schlummern bis zu 20 Stunden. Womöglich brauchen die Kleinen so viel Ruhe, weil ihr Stoffwechsel schneller arbeitet und der Körper mehr Zeit benötigt, um sich von all den Herzschlägen, Atemzügen und Verdauungsvorgängen zu erholen.`}</p>
    <h5>Die seltsamsten Verhaltensweisen beim Schlafen in der Tierwelt</h5>
    <Image file={require('images/icon_st_01.png')} className='tier right' mdxType="Image" /> <b>Potwale</b> nehmen beim Schlafen eine senkrechte Position im Wasser ein. Sie schlafen etwa zwei Stunden.<br /><br />
    <Image file={require('images/icon_st_02.png')} className='tier left' mdxType="Image" /> <b>Sepien</b> erleben so wie Menschen eine REM-Schlafphase. Sie wechseln dabei die Farbe und zucken mit den Armen. Sie schlafen etwa 8 Stunden.<br /><br />
    <Image file={require('images/icon_st_03.png')} className='tier right' mdxType="Image" /> <b>Seeotter</b> wickeln sich zum Schlafen in Algen ein oder halten einander an den Pfoten um nicht abzutreiben.<br /><br />
    <Image file={require('images/icon_st_04.png')} className='tier right' mdxType="Image" /> <b>Walrösser</b> bleiben 84 Stunden wach und schlafen dann für 19 Stunden.<br /><br />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;